import { Clock, Database, Mail, Shield } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const featureIcons: LucideIcon[] = [Clock, Database, Mail, Shield];

export const getFeatureIcon = (index: number): LucideIcon => 
  featureIcons[index % featureIcons.length];